import {createReducer} from 'redux-act'

import * as actions from "#app/redux/actions/task";

/**
 * Перечисление типов, которыми может обладать таска
 * @type {Readonly<{NEW: {id: string, title: string}, EDIT: {id: string, title: string}, EVENT: {id: string, title: string}}>}
 */
export const TASK_FORM_TYPES = Object.freeze({
  NEW: { id: 'new', title: 'Новое событие' },
  EVENT: { id: 'event', title: 'Событие' },
  EDIT: { id: 'edit', title: 'Редактирование' },
});

let task = {
  modalVisible: false,
  form: {},
  type: TASK_FORM_TYPES.EVENT,
};

const setTaskModalVisible = (state, bool) => {
  return {
    ...state,
    modalVisible: bool,
  }
}

const setTaskForm = (state, form) => {
  return {
    ...state,
    form: form
  }
}

const setTaskType = (state, type = null) => {
  return {
    ...state,
    type: type ?? TASK_FORM_TYPES.NEW
  }
}


const reducer = createReducer({
  [actions.setTaskModalVisible]: setTaskModalVisible,
  [actions.setTaskForm]: setTaskForm,
  [actions.setTaskType]: setTaskType,
}, task)

export default reducer
